import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BuilderRequest } from 'src/app/models/requests';

@Component({
  selector: 'app-flow-navigation',
  templateUrl: './flow-navigation.component.html',
  styleUrls: ['./flow-navigation.component.css']
})
export class FlowNavigationComponent implements OnInit {

  @Input() enableSendRequestAction: any;
  @Input() request!: BuilderRequest;
  @Input() currentTab: string = "AddDocuments";
  @Input() currentStep!: any;
  @Input() disabled!: any;
  @Input() progress:number[] = [0,0,0]; 
  @Output() sendRequest = new EventEmitter();
  @Output() activeTab = new EventEmitter();
  
  enableSendRequest = false;
  accordionItem: any;
  previousTab !: string;

  constructor() {
    // Must not be empty. It's approved by a comment.
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  async send() {
    this.sendRequest.emit("Send")
  }

  getActiveTab(event: any) {
    this.currentTab = event;
    this.accordionItem = document.getElementById(""+ this.previousTab[0].toLowerCase() + this.previousTab.slice(1) + "-panel");
    this.accordionItem.classList.remove('show');
    this.accordionItem = document.getElementById(""+ this.currentTab[0].toLowerCase() + this.currentTab.slice(1) + "-panel");
    this.accordionItem.classList.add('show');
    this.activeTab.emit(event);
  }

  next() {
    switch(this.currentTab) {
      case "AddDocuments": {
        this.currentTab = "AddPersons";
        this.previousTab = "addDocuments";
        break;
      }
      case "AddPersons": {
        this.currentTab = "AddActions";
        this.previousTab = "addPersons";
        break;
      }
      case "AddActions": {
        this.currentTab = "ReviewAndSend";
        this.previousTab = "addActions";
        break;
      }
      case "ReviewAndSend": {        
        this.previousTab = "reviewAndSend";
        break;
      }
      default: {
        break;
      }
    }
    this.getActiveTab(this.currentTab);
  }

  previous() {
    switch(this.currentTab) {
      case "AddDocuments": {
        this.currentTab = "AddDocuments";
        this.previousTab = "addDocuments";
        break;
      }
      case "AddPersons": {
        this.currentTab = "AddDocuments";
        this.previousTab = "AddPersons";
        break;
      }
      case "AddActions": {
        this.currentTab = "AddPersons";
        this.previousTab = "addActions";
        break;
      }
      case "ReviewAndSend": {     
        this.currentTab = "AddActions";
        this.previousTab = "reviewAndSend";
        break;
      }
      default: {
        break;
      }
    }
    this.getActiveTab(this.currentTab);
  }

  disableNextButton() {
    switch(this.currentTab) {
      case "AddDocuments": {
        if(this.progress[0] === 100) return false;
        break;
      }
      case "AddPersons": {
        if(this.progress[0] === 100 && this.progress[1] === 100) return false;
        break;
      }
      case "AddActions": {
        if(this.progress[0] === 100 && this.progress[1] === 100 && this.progress[2] === 100) return false;
        break;
      }
      default: {
        break;
      }
    }
    return true;
  }
}
